import type { Cart, LineItem } from 'src/types/cart'
import formatVariant from './formatVariant'

const ENTERPRISE_ID = 1565492

const staticMapPageType: Record<string, string> = {
  '/': 'homepage',
  '/products': 'productDetail'
}

function convertShopifyLineItemsToCJItems(lineItems: LineItem[], productMap) {
  return lineItems.map((item) => {
    const variant = item?.node?.merchandise
    const fullVariantId = variant.id // e.g. "gid://shopify/ProductVariant/39848003141714"
    const variantIdBreakdown = fullVariantId.split('/')
    const variantId = variantIdBreakdown[variantIdBreakdown.length - 1]

    const variantMap = productMap?.byVariantId

    const product = variantMap[variantId]
    const hasSubscription = Boolean(item?.node?.sellingPlanAllocation)
    const { price, subDiscount } = formatVariant(item.node, variantMap)
    const subscriptionAdjustment = hasSubscription ? subDiscount : 0
    const unitPrice = price - subscriptionAdjustment
    return {
      unitPrice,
      itemId: variantId || product?.single?.variantId.decoded,
      quantity: item.node.quantity,
      discount: 0
    }
  })
}

function mapPageType(currentPath: string) {
  if (staticMapPageType[currentPath]) return staticMapPageType[currentPath]
  if (currentPath.includes('/products/')) return 'productDetail'
  return 'homepage'
}

export const updateCJSitePage = (currentPath: string, cart: Cart, productMap: any) => {
  if (!window.cj) window.cj = {}
  const items = convertShopifyLineItemsToCJItems(cart.lines.edges, productMap)

  window.cj.sitePage = {
    enterpriseId: ENTERPRISE_ID,
    pageType: mapPageType(currentPath),
    cartSubtotal: cart.cost.subtotalAmount.amount,
    items
  }

  var a = 'https://www.mczbf.com/tags/559012995205/tag.js'
  var b = document
  var c = 'script'
  var d = b.createElement(c)
  d.src = a
  d.type = 'text/java' + c
  d.async = true
  d.id = 'cjapitag'
  a = b.getElementsByTagName(c)[0]
  a.parentNode.insertBefore(d, a)
}
